<script>
  import * as PropTypes from "prop-types";
  const { checkPropTypes, array, string, object } = PropTypes;
  import { onMount } from "svelte";
  export let item = item;

  export const personJson = {
    "@context": "https://schema.org",
    "@type": "personJson",
    name: (item.h || "").trim() || item.n,
    gender: item.gender || "M",
    url: `https://mojapp.in/@${item.h}`,
    alternateName: item.n,
    interactionStatistic: [
      {
        "@type": "InteractionCounter",
        interactionType: {
          "@type": "http://schema.org/FollowAction", // no of followers
        },
        userInteractionCount: item.a,
      },
      {
        "@type": "InteractionCounter",
        interactionType: {
          "@type": "http://schema.org/FollowAction", // no of likes
        },
        userInteractionCount: item.likeCount,
      },
      {
        "@type": "InteractionCounter",
        interactionType: {
          "@type": "http://schema.org/FollowAction", // no of following
        },
        userInteractionCount: item.b,
      },
    ],
  };
  const propTypes = {
    personJson: object,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "ProfileItemHead");
  });
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html `<script type="application/ld+json">${`${JSON.stringify(
  personJson
)}<`}/script>`}
